module.exports = new __parcel__URL__("lucidchart.8807407a.png").toString();